export default "__VITE_ASSET__BQCVrwaM__"